// src/services/userService.js

import axios from "axios";

const BASE_URL = "http://staging.maamaas.com:8080/protohub/api";


const BASE_URL2 = "http://staging.maamaas.com:8080/protohub/";

export const getUsers = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/users`);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const getVendors = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/vendors`);
        return response.data;
    } catch (error) {
        console.error("Error fetching vendors:", error);
        throw error;
    }
};
// Fetches all facilities — used to populate the Centres table
export const getCenters = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/vendor/facilities/all`);
        return response.data;
    } catch (error) {
        console.error("Error fetching centres:", error);
        throw error;
    }
};


export const getAvailableMachines = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/vendor/machines/available`);
        return response.data;
    } catch (error) {
        console.error("Error fetching machines:", error);
        throw error;
    }
};

// Fetches all user enquiries — used to populate the Projects table
export const getEnquiries = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/user/enquiry/getAll`);
        return response.data;
    } catch (error) {
        console.error("Error fetching enquiries:", error);
        throw error;
    }
};

// Fetches all bookings — used to populate the Order Management table
export const getBookings = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/admin/bookings`);
        return response.data;
    } catch (error) {
        console.error("Error fetching bookings:", error);
        throw error;
    }
};




// Fetches all support tickets — used to populate the Support dashboard
export const getSupportTickets = async () => {
    try {
        const response = await axios.get(`${BASE_URL2}/support/ticket/getall`);
        return response.data;
    } catch (error) {
        console.error("Error fetching support tickets:", error);
        throw error;
    }
};

// Updates a support ticket's status
// status must be one of: OPEN, IN_PROGRESS, RESOLVED, CLOSED
export const updateSupportTicketStatus = async (ticketId, status) => {
    try {
        const response = await axios.put(
            `${BASE_URL2}/support/ticket/status/${ticketId}`,
            null,
            { params: { status } }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating support ticket status:", error);
        throw error;
    }
};